
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import PromotionSection from './components/PromotionSection';
import MembershipSection from './components/MembershipSection';
import AboutSection from './components/AboutSection';
import ProgramsSection from './components/ProgramsSection';
import GallerySection from './components/GallerySection';
import RegisterSection from './components/RegisterSection';
import ContactSection from './components/ContactSection';

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <HeroSection />
        <PromotionSection />
        <MembershipSection />
        <AboutSection />
        <ProgramsSection />
        <GallerySection />
        <RegisterSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
